import React, { CSSProperties } from "react";
import Script from "next/script";
import cn from "classnames";
interface IconFontProps {
  type: string;
  className?: string;
  style?: CSSProperties;
  onClick?: Function;
}
export default function IconFont({
  type,
  className,
  style,
  onClick,
}: IconFontProps) {
  return (
    <>
      <Script src="/iconfont/iconfont.js" />

      <svg
        className={cn("icon", className)}
        aria-hidden="true"
        onClick={onClick as any}
        style={style}
      >
        <use xlinkHref={"#rf-" + type}></use>
      </svg>
    </>
  );
}
